import React, { useState } from 'react';
import { HammerUIProvider } from '@liveauctioneers/hammer-ui-core/providers';
import { proxibidTheme } from '@liveauctioneers/hammer-ui-core/theme/proxibid';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useBidderSessionExpiresSoon } from '@liveauctioneers/hammer-ui-proxibid-utils/hooks';
import PropTypes from 'prop-types';
import { CookieService } from '@proxibid/proxiponents';
import GTMEventService from '../shared/GTM-event-service'; 

BidderSessionWarningDialog.propTypes = {
    isFeatureEnabled: PropTypes.bool,
    isLoggingEnabled: PropTypes.bool,
    sessionExpirationCheckInSeconds: PropTypes.number,
    customLogoutUser: PropTypes.func
};

const getIsUserLoggedIn = () => {
    const guid = CookieService.getCookieValue("guid");
    return guid && guid !== "";
}

export function BidderSessionWarningDialog(props) {

    const {
        alertShown,
        handleClose,
        handleLoginButtonClicked,
        loginButtonClicked,
        modalMessage,
        modalTitle,
    } = useBidderSessionExpiresSoon({
        isFeatureEnabled: props.isFeatureEnabled,
        getIsUserLoggedIn: getIsUserLoggedIn,
        isLoggingEnabled: props.isLoggingEnabled,
        modalListener: createModalListener(),
        sessionExpirationCheckInSeconds: props.sessionExpirationCheckInSeconds,
        customLogoutUser: props.customLogoutUser
    });

    return (
        <HammerUIProvider theme={proxibidTheme} normalizationType={'scoped'}>
            <Dialog
                open={alertShown}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{modalTitle}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Typography>
                            {modalMessage}
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleLoginButtonClicked} color="primary" disabled={loginButtonClicked}>
                        Login
                    </Button>
                </DialogActions>
            </Dialog>
        </HammerUIProvider>
    );
}

const createModalListener = () => {
    return {
        logoutOccurred: () => GTMEventService.triggerEvent('bsedLogout'),
        modalCancelClicked: () => GTMEventService.triggerEvent('bsedCancel'),
        modalLoginClicked: () => GTMEventService.triggerEvent('bsedLogin'),
        modalShown: () => GTMEventService.triggerEvent('bsedDisplay'),
    };
};

export default BidderSessionWarningDialog;